import React, { useEffect, useRef } from 'react';

let tvScriptLoadingPromise;

 function TradingViewWidgettx() {
  const onLoadScriptRef = useRef();

  useEffect(
    () => {
      onLoadScriptRef.current = createWidget;

      if (!tvScriptLoadingPromise) {
        tvScriptLoadingPromise = new Promise((resolve) => {
          const script = document.createElement('script');
          script.id = 'tradingview-widget-loading-script';
          script.src = 'https://s3.tradingview.com/tv.js';
          script.type = 'text/javascript';
          script.onload = resolve;

          document.head.appendChild(script);
        });
      }

      tvScriptLoadingPromise.then(() => onLoadScriptRef.current && onLoadScriptRef.current());

      return () => onLoadScriptRef.current = null;

      function createWidget() {
        if (document.getElementById('tradingview_2841e') && 'TradingView' in window) {
          new window.TradingView.widget({
            autosize: true,
            symbol: "SPREADEX:SPX",
            interval: "D",
            timezone: "America/New_York",
            theme: "dark",
            style: "1",
            locale: "en",
            enable_publishing: false,
            allow_symbol_change: true,
            container_id: "tradingview_2841e",
            height: "500px"
          });
        }
      }
    },
    []
  );

  return (
    <div style={{textAlign:"center"}}>
    <div className='tradingview-widget-container' style={{ height: "800px", borderBottom:"1px solid white", width: "100%" }}>
    <div id='tradingview_2841e' style={{ height: "calc(100% - 32px)", width: "100%" }} />
    <div className="tradingview-widget-copyright">
    </div>
  </div>
  <button onClick={() => {alert("Your account is not yet activated to use the live trading portal")}} style={{margin:"1.5rem"}}>Start Live Trading</button>
  </div>
  );
}

export default TradingViewWidgettx;